import React from 'react';
import Base from "./Base"
import { Card, Row, Col, Collapse, Form, Input, Popover, Button, Spin, message, Select, Modal, Tooltip, Icon, Upload} from "antd"
import { withRouter } from 'react-router-dom';
import { API, Auth, Storage } from "aws-amplify"
import {CustomSpinner} from "../../Components/Spin/CustomSpiner"
import { connect } from "react-redux"
import definitions from '../../Util/AFIPdefinitions'
import { allState as mapStateToProps, allDispatch as mapDispatchToProps} from "../../Redux/Selectors"
import BaseUserLite from "../UserLite/BaseUserLite";

function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
        message.error('Solo puedes subir imágenes en formato JPG/PNG!');
    }
    const isLt3M = file.size / 1024 / 1024 < 5;
    if (!isLt3M) {
        message.error('La imagen debe ser menor de 5MB!');
    }
    return isJpgOrPng && isLt3M;
}
const {Option} = Select;
const { Panel } = Collapse;

class Micuenta extends React.Component {

    constructor (props){
        super(props);
        this.state={
            user:{
            },
            new_data:{
            },
            loading:true,
            editting: false,
            visible:false,
            bajaMonotributo:false,
            loadingImage:false,
        };

    };


    onChange(image, idFoto) {
        this.setState({loadingImage:true})
                Storage.put(this.state.user.email.toLowerCase() + '/'+idFoto, image, {
                    level:'public',
                    contentType: 'image/jpg'
                })
                .then (result => {
                    message.success("Foto Cargada con Exito")
                    let usr = {...this.state.user}
                    usr[idFoto]=true
                    this.setState({user:usr, loadingImage:false})
                    this.call_api(true)

                })
                .catch(err => {
                    console.log(err)
                    this.setState({loadingImage:false})
                });

    }


    call_api = (foto) => {

        if (foto===true){
            this.send_data()
        } else{
            this.props.form.validateFieldsAndScroll( { first: true }, (err, values) => {
                if (!err) {
                    this.send_data()
                }})
            }
        }

    send_data=()=>{
                    Auth.currentSession()
                        .then(session => {
                                API.put(
                                    'test',
                                    '/root/users/me',
                                    {
                                        headers: {
                                            Authorization: session.getIdToken().getJwtToken()
                                        },
                                        body: {
                                                nombre: this.state.user.nombre,
                                                apellido: this.state.user.apellido,
                                                razon_social:this.state.user.razon_social,
                                                email: this.state.user.email,
                                                telefono: this.state.user.telefono,
                                                direccion: this.state.user.direccion,
                                                ciudad: this.state.user.ciudad,
                                                provincia: this.state.user.provincia,
                                                cp: this.state.user.cp,
                                                cuit: this.state.user.cuit,
                                                clave_fiscal: this.state.user.clave_fiscal,
                                                cur: this.state.user.cur,
                                                inicio_actividad: this.state.user.inicio_actividad,
                                                aportes_sipa: this.state.user.aportes_sipa,
                                                os: this.state.user.os,
                                                familiares_os: this.state.user.familiares_os,
                                                cuit_empleador: this.state.user.cuit_empleador,
                                                iibb: this.state.user.iibb,
                                                iibb_numero:this.state.user.iibb_numero,
                                                local_comercial: this.state.user.local_comercial,
                                                costo_alquiler: this.state.user.costo_alquiler,
                                                actividad_1: this.state.user.actividad_1,
                                                actividad_2: this.state.user.actividad_2,
                                                actividad_3: this.state.user.actividad_3,
                                                estado_usuario: this.state.user.estado_usuario,
                                                estado_pago:this.state.user.estado_pago,
                                                estdo_monotributo:this.state.user.estado_monotributo,
                                                estado_clave_fiscal:this.state.user.estado_clave_fiscal,
                                                plan: this.state.user.plan,
                                                plan_id:this.state.user.plan_id,
                                                fecha_inicio: this.state.user.fecha_inicio,
                                                fecha_fin: this.state.user.fecha_fin,
                                                foto_dni_fr:this.state.user.foto_dni_fr,
                                                foto_dni_tr:this.state.user.foto_dni_tr,
                                                foto_rostro:this.state.user.foto_rostro

                                        }
                                    }
                                )
                                    .then(response => {
                                        message.success("Usuario actualizado")
                                        this.setState({loading: false })
                                        if (this.state.user.foto_rostro && this.state.user.foto_dni_fr && this.state.user.foto_dni_tr){
                                            this.props.history.push('/')
                                        }

                                    })
                                    .catch(err => {
                                            message.error("Error de actualización de usuario")
                                            this.setState({ loading: false })
                                    })

                        })
                        .catch(err => {
                            message.error("Error obteniendo credenciales de usuario")
                            console.log(err)
                        })
    }

    call_delete = () => {
        let fields = []
        this.props.form.validateFieldsAndScroll(fields, { first: true }, (err, values) => {
            if (!err) {
                    this.setState({ loading: true })
                    Auth.currentSession()
                        .then(session => {
                                API.put(
                                    'test',
                                    '/root/users/me',
                                    {
                                        headers: {
                                            Authorization: session.getIdToken().getJwtToken()
                                        },
                                        body: {
                                            baja:this.state.bajaMonotributo
                                        }
                                    }
                                )
                                    .then(response => {
                                        message.success("Solicitud de Baja enviada")
                                        this.setState({loading: false })
                                        this.props.history.push('/')
                                    })
                                    .catch(err => {

                                            message.error("Error de actualización de usuario")
                                            this.setState({ loading: false })
                                    })

                        })
                        .catch(err => {
                            message.error("Error obteniendo credenciales de usuario")
                            console.log(err)
                        })
            }
        })

    }

    componentDidMount(){
        Auth.currentSession()
        .then(response => {
            API.get(
                'test',
                '/root/users/me',
                {
                    headers: {
                        Authorization: response.getIdToken().getJwtToken()
                    }
                }
            )
                .then(response => {
                    this.setState({ user: response, new_data:response, loading:false})
                })
                .catch(err =>{
                    message.error('Error cargando datos de usuarios')
                    this.props.Logout()
                    this.props.history.push('/login')
                })
            })
        .catch(err => {
            message.error('Sesion vencida, vuelve a loguearte por favor')
            this.props.Logout()
            this.props.history.push('/login')
        })

    }

    baja_todo = () =>{
        this.setState({bajaMonotributo:true, visible:false})
        this.call_delete()
    }

    baja_liqui = () =>{
        this.setState({bajaMonotributo:false, visible:false})
        this.call_delete()
    }

    showModal=()=>{
        this.setState({visible:true,})
    };

    handleOk = e =>{
        console.log(e);
        this.setState({
            visible:false,
        })
    }

    handleCancel = e =>{
        console.log(e);
        this.setState({visible:false})
    }

    upDateState = ()=>{
        const new_user = this.state.new_data
        this.setState({user: new_user, editting:false})
        this.call_api(false)
    }

    isEditing = ()=>{
        this.setState({editting:true})
    }

    updateData(field, value) {
        const user = {...this.state.user}
        user[field] = value
        this.setState({ new_data:user })
    }

    cancel = () => {
        this.setState({editting:false});
        this.props.form.resetFields();
    }

    isBajaOrInactivo = () => {
        return this.state.user.estado_usuario === 'BAJA' || this.state.user.estado_usuario === 'INACTIVO'
    }

    render() {
        const BaseComponent = this.props.login.userLite ? BaseUserLite : Base;

        if(this.state.loading){
            return (
                <BaseComponent
            >
                <Row></Row>
                <Row type="flex" justify="space-around" align="middle" style={{marginTop:'150px'}}>
                <Col style={{minHeight:'360px'}}>
                    <Spin indicator={CustomSpinner}/>
                </Col>
            </Row>
            <Row></Row>
                </BaseComponent>)
        } else{


        const cuitValidator = (rule, value, callback) => {

                if (typeof(value) === 'undefined' || value === null || value === '') {
                    callback('CUIT requerido')
                }

                value = value.toString().replace(/\W/g, "");
                if (value === '') {
                    callback('CUIT requerido')
                }
                else if (value.length !== 11) {
                    callback('El cuit debe tener 11 numeros')
                }
                else {
                    var mult = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
                    var total = 0;
                    for (var i = 0; i < mult.length; i++) {
                        total += parseInt(value[i]) * mult[i];
                    }
                    var mod = total % 11;
                    var digito = mod === 0 ? 0 : mod === 1 ? 9 : 11 - mod;
                }
                if (digito === parseInt(value[10])) {
                    callback()

                } else {
                    callback('CUIT invalido')
                }
        }

        const { getFieldDecorator } = this.props.form;

        const bajaLabel = (this.isBajaOrInactivo()) ? 
            <>
                <p>Como tu usuario ya no esta activo, no podremos realizar tu baja del monotributo.</p>
                <p>Si deseas que te ayudemos nuevamente, por favor reactiva tu cuenta.</p>   
            </> :
            <>
                <p>Lamentamos mucho que te vayas.. =(</p>
                <p><b>Por favor indicanos si deseas tu baja solo en Liqui o si tambien deseas la baja del monotributo en AFIP</b></p>
            </>
            
        const aclaracion = <b>Recorda leer estas aclaraciones antes de subir tus fotos</b>

        return (

            <BaseComponent
                selected="micuenta"
            >
                    <Button
                        style={{marginBottom:10, marginTop:10, marginLeft:5, marginRight:5}}
                        type={"primary"}
                        disabled={this.state.editting}
                        icon="edit"
                        onClick={this.isEditing}
                        >Editar</Button>

                        <Button
                        style={{marginBottom:10, marginTop:10, marginLeft:5, marginRight:5}}
                        type={"primary"}
                        icon="save"
                        disabled={!this.state.editting}
                        onClick={this.upDateState}
                        >Guardar</Button>

                        <Button
                        style={{marginBottom:10, marginTop:10, marginLeft:5, marginRight:5}}
                        disabled={!this.state.editting}
                        icon="close"
                        onClick={this.cancel}
                        >Cancelar</Button>

                        <Collapse defaultActiveKey={['1']}>
                            <Panel header={aclaracion} key="1">
                                <Row>
                                    <Col lg={8}>
                                        <p>Sacate una selfie y recordá:</p>
                                        <ul>
                                            <li>Sin anteojos ni gorra</li>
                                            <li>Fondo claro y bien iluminado</li>
                                            <li>Rostro de frente</li>
                                        </ul>
                                    </Col>
                                    <Col lg={6}>
                                        <p>Sacale una foto a tu DNI y recordá:</p>
                                        <ul>
                                            <li>Debe ser legible</li>
                                            <li>No debe tener brillo (sin flash)</li>
                                            <li>Trata de enfocar todo el carnet</li>
                                        </ul>
                                    </Col>
                                </Row>
                            </Panel>
                        </Collapse>
                        <Collapse style={{marginBottom:10}} defaultActiveKey={[1]}>
                            <Panel header="Adjuntar Fotos" key="1">
                                <Row gutter={[8,8]}>
                                    <Col lg={8} style={{marginTop:10, marginBottom:10}}>
                                        <Upload
                                            name='dniAdelante'
                                            method='get'
                                            accept='.png,.jpg'
                                            action ={(evt)=>this.onChange(evt,'foto_dni_fr')}
                                            beforeUpload={beforeUpload}
                                            disabled={this.state.user.foto_dni_fr && !this.state.editting}
                                        >
                                        <Popover placement ='bottom' content={<div><p><b>Formato:</b> .jpg o .png</p><p><b>Tamaño Max:</b> 5MB</p></div>}>
                                        <Button disabled={this.state.user.foto_dni_fr && !this.state.editting} loading={this.state.loadingImage} style ={{width:320}}>
                                            <Icon type='upload'></Icon> Foto DNI adelante
                                        </Button>
                                        </Popover>
                                        </Upload>
                                    </Col>
                                    <Col lg={8} style={{marginTop:10, marginBottom:10}}>
                                        <Upload
                                            name='dniAtras'
                                            method='get'
                                            accept='.png,.jpg'
                                            action ={(evt)=>this.onChange(evt, 'foto_dni_tr')}
                                            beforeUpload={beforeUpload}
                                            disabled={this.state.user.foto_dni_tr && !this.state.editting}
                                        >
                                            <Popover placement ='bottom' content={<div><p><b>Formato:</b> .jpg o .png</p><p><b>Tamaño Max:</b> 5MB</p></div>}>
                                        <Button disabled={this.state.user.foto_dni_tr && !this.state.editting} loading={this.state.loadingImage} style ={{width:320}} >
                                            <Icon type='upload'></Icon> Foto DNI Atras
                                        </Button>
                                        </Popover>
                                        </Upload>
                                    </Col>
                                    <Col lg={8} style={{marginTop:10, marginBottom:10}}>
                                        <Upload
                                            name='rostro'
                                            method='get'
                                            accept='.png,.jpg'
                                            action ={(evt)=>this.onChange(evt, 'foto_rostro')}
                                            beforeUpload={beforeUpload}
                                            disabled={this.state.user.foto_rostro && !this.state.editting}
                                        >
                                        <Popover placement ='bottom' content={<div><p><b>Formato:</b> .jpg o .png</p><p><b>Tamaño Max:</b> 5MB</p></div>}>
                                        <Button disabled={this.state.user.foto_rostro && !this.state.editting} loading={this.state.loadingImage} style ={{width:320}}>
                                            <Icon type='upload'></Icon> Foto rostro
                                        </Button>
                                        </Popover>
                                        </Upload>
                                    </Col>
                                </Row>
                            </Panel>
                        </Collapse>
                        
                        <Card   style={{ marginBottom: "10px" }}
                                title={"Datos Personales"}
                        >


                        <Row gutter={[8,8]}>
                            <Col lg={6}>
                            <Form.Item label="Nombre">{
                                getFieldDecorator('nombre',{
                                rules: [{
                                    required: false,
                                    message: 'Nombre requerido'
                                },
                            ],
                                initialValue: this.state.user.nombre
                            })(
                                <Input
                                    disabled={true}
                                    onChange={(e) => this.updateData("nombre", e.target.value ? e.target.value : null)}
                                />
                            )
                            }
                            </Form.Item>
                            </Col>

                            <Col lg={6}>
                            <Form.Item label="Apellido">{
                                getFieldDecorator('apellido',{
                                rules: [{
                                    required: false,
                                    message: 'Apellido requerido'
                                }],
                                initialValue: this.state.user.apellido
                            })(
                                <Input
                                    disabled={true}
                                    onChange={(e) => this.updateData("apellido", e.target.value ? e.target.value : null)}
                                />
                            )
                            }
                            </Form.Item>
                            </Col>

                            <Col lg={6}>
                            <Form.Item label="Email">{
                                getFieldDecorator('email',{
                                rules: [{
                                    required: false,
                                    message: 'Mail requerido'
                                }],
                                initialValue: this.state.user.email
                            })(
                                <Input
                                    disabled={true}
                                    onChange={(e) => this.updateData("email", e.target.value ? e.target.value : null)}
                                />
                            )
                            }
                            </Form.Item>
                            </Col>

                            <Col lg={6}>
                            <Form.Item label="Telefono">{
                                getFieldDecorator('telefono',{
                                rules: [{
                                    required: true,
                                    message: 'Telefono requerido',
                                },

                            ],
                                initialValue: this.state.user.telefono
                            })(
                                <Input
                                    disabled={!this.state.editting}
                                    onChange={(e) => this.updateData("telefono", e.target.value ? e.target.value : null)}
                                />
                            )
                            }
                            </Form.Item>
                            </Col>
                    </Row>
                    <Row gutter={[8,8]}>
                        <Col lg={8}>

                        </Col>
                        <Col lg={8}>

                        </Col>
                        <Col lg={8}>

                        </Col>
                    </Row>

                    <Row gutter={[8,8]}>

                            <Col lg={6}>
                            <Form.Item label="Direccion">{
                                getFieldDecorator('direccion',{
                                rules: [{
                                    required: false,
                                    message: 'direccion requerido'
                                }],
                                initialValue: this.state.user.direccion
                            })(
                                <Input
                                    disabled={true}
                                    onChange={(e) => this.updateData("direccion", e.target.value ? e.target.value : null)}
                                    suffix={
                                        <Tooltip title="Direccion con que te diste de alta en AFIP">
                                            <Icon type="info-circle" />
                                        </Tooltip>
                                    }
                                />
                            )
                            }
                            </Form.Item>
                            </Col>

                            <Col lg={6}>
                            <Form.Item label="Ciudad">{
                                getFieldDecorator('ciudad',{
                                rules: [{
                                    required: false,
                                    message: 'ciudad requerido'
                                }],
                                initialValue: this.state.user.ciudad
                            })(
                                <Input
                                    disabled={true}
                                    onChange={(e) => this.updateData("ciudad", e.target.value ? e.target.value : null)}
                                />
                            )
                            }
                            </Form.Item>
                            </Col>

                            <Col lg={6}>
                            <Form.Item label="Código Postal">{
                                getFieldDecorator('cp',{
                                rules: [{
                                    required: false,
                                    message: 'CP requerido',
                                }
                            ],
                                initialValue: this.state.user.cp
                            })(
                                <Input
                                    disabled={true}
                                    onChange={(e) => this.updateData("cp", e.target.value ? e.target.value : null)}
                                />
                            )
                            }
                            </Form.Item>
                            </Col>

                            <Col lg={6}>
                            <Form.Item label="Provincia">{
                                getFieldDecorator('provincia',{
                                rules: [{
                                    required: false,
                                    message: 'Provincia requerida'
                                }],
                                initialValue: this.state.user.provincia
                            })(
                                <Select
                                    style={{ width: 240}}
                                    disabled={true}
                                    onChange={(value) => this.updateData("provincia", value )}
                                >
                                    {definitions.provincia.map(prov=>{
                                        return <Option key={prov.value} value={prov.value}>{prov.name}</Option>
                                    })}
                            </Select>
                            )
                            }
                            </Form.Item>
                            </Col>

                    </Row>

                    </Card>

                        <Card
                            style={{ marginBottom: "10px" }}
                            title={"Datos Impositivos"}>
                        <Row gutter={[8,8]}>

                            <Col lg={6}>
                            <Form.Item label="CUIT">{
                                getFieldDecorator('cuit',{
                                    rules: [{
                                        required: true,
                                        validator: cuitValidator
                                    }],
                                initialValue: this.state.user.cuit
                            })(
                                <Input
                                    disabled={!this.state.editting}
                                    onChange={(e) => this.updateData("cuit", e.target.value ? e.target.value : null)}
                                />
                            )}
                            </Form.Item>
                            </Col>

                            <Col lg={6}>
                            <Form.Item label="Clave Fiscal">{
                                getFieldDecorator('clave_fiscal',{
                                rules: [{
                                    required: true,
                                    message: 'Clave fiscal requerido'
                                }],
                                initialValue: this.state.user.clave_fiscal
                            })(
                                <Input
                                    disabled={!this.state.editting}
                                    onChange={(e) => this.updateData("clave_fiscal", e.target.value ? e.target.value : null)}
                                />
                            )}
                            </Form.Item>
                            </Col>

                            <Col lg={6}>
                            <Form.Item label="CUR">{
                                getFieldDecorator('cur',{
                                initialValue: this.state.user.cur
                            })(
                                <Input
                                    disabled={true}
                                    onChange={(e) => this.updateData("cur", e.target.value ? e.target.value : null)}
                                />
                            )}
                            </Form.Item>
                            </Col>

                            <Col lg={6}>
                            <Form.Item label="Fecha Inicio Actividad">{
                                getFieldDecorator('inicio_actividad',{
                                initialValue: this.state.user.inicio_actividad
                            })(
                                <Input
                                    disabled={true}
                                    onChange={(e) => this.updateData("inicio_actividad", e.target.value ? e.target.value : null)}
                                />
                            )}
                            </Form.Item>
                            </Col>
                    </Row>

                    <Row gutter={[8,8]}>

                            <Col lg={6}>
                            <Form.Item label="Aportes SIPA">{
                                getFieldDecorator('aportes_sipa',{
                                initialValue: this.state.user.aportes_sipa
                            })(
                                <Input
                                    disabled={true}
                                    onChange={(e) => this.updateData("aportes_sipa", e.target.value ? e.target.value : null)}
                                />
                            )}
                            </Form.Item>
                            </Col>

                            <Col lg={6}>
                            <Form.Item label="Obra Social.">{
                                getFieldDecorator('os',{
                                initialValue: this.state.user.os
                            })(
                                <Input
                                    disabled={true}
                                    onChange={(e) => this.updateData("os", e.target.value ? e.target.value : null)}
                                />
                            )}
                            </Form.Item>
                            </Col>

                            <Col lg={6}>
                            <Form.Item label="Familiares O.S">{
                                getFieldDecorator('adherentes',{
                                initialValue: this.state.user.familiares_os
                            })(
                                <Input
                                    disabled={true}
                                    onChange={(e) => this.updateData("familiares_os", e.target.value ? e.target.value : null)}
                                />
                            )}
                            </Form.Item>
                            </Col>

                            <Col lg={6}>
                            <Form.Item label="CUIT Empleador">{
                                getFieldDecorator('cuit_empleador',{
                                initialValue: this.state.user.cuit_empleador
                            })(
                                <Input
                                    disabled={true}
                                    onChange={(e) => this.updateData("cuit_empleador", e.target.value ? e.target.value : null)}
                                />
                            )}
                            </Form.Item>
                            </Col>
                            </Row>

                            <Row gutter={[8,8]}>

                            <Col lg={6}>
                            <Form.Item label="Categoria IIBB">{
                                getFieldDecorator('iibb',{
                                initialValue: this.state.user.iibb
                            })(
                                <Input
                                    disabled={true}
                                    onChange={(e) => this.updateData("iibb", e.target.value ? e.target.value : null)}
                                />
                            )}
                            </Form.Item>
                            </Col>

                            <Col lg={6}>
                            <Form.Item label="Nro. IIBB">{
                                getFieldDecorator('nro_iibb',{
                                initialValue: this.state.user.iibb_numero
                            })(
                                <Input
                                    disabled={true}
                                    onChange={(e) => this.updateData("iibb_numero", e.target.value ? e.target.value : null)}
                                />
                            )}
                            </Form.Item>
                            </Col>

                            <Col lg={6}>
                            <Form.Item label="m2 local comercial">{
                                getFieldDecorator('esp_fisico',{
                                initialValue: this.state.user.local_comercial
                            })(
                                <Input
                                    disabled={true}
                                    onChange={(e) => this.updateData("local_comercial", e.target.value ? e.target.value : null)}
                                />
                            )}
                            </Form.Item>
                            </Col>


                            <Col lg={6}>
                            <Form.Item label="Costo Alquiler">{
                                getFieldDecorator('costo_alquiler',{
                                initialValue: this.state.user.costo_alquiler
                            })(
                                <Input
                                    disabled={true}
                                    onChange={(e) => this.updateData("costo_alquiler", e.target.value ? e.target.value : null)}
                                />
                            )}
                            </Form.Item>
                            </Col>
                            </Row>
                            <Row gutter={[8,8]}>

                            <Col lg={8}>
                            <Form.Item label="Actividad a desarrollar 1">{
                                getFieldDecorator('actividad_1',{
                                initialValue: this.state.user.actividad_1
                            })(
                                <Input
                                    disabled={true}
                                    onChange={(e) => this.updateData("actividad_1", e.target.value ? e.target.value : null)}
                                />
                            )}
                            </Form.Item>
                            </Col>

                            <Col lg={8}>
                            <Form.Item label="Actividad a desarrollar 2">{
                                getFieldDecorator('actividad_2',{
                                initialValue: this.state.user.actividad_2
                            })(
                                <Input
                                    disabled={true}
                                    onChange={(e) => this.updateData("actividad_2", e.target.value ? e.target.value : null)}
                                />
                            )}
                            </Form.Item>
                            </Col>

                            <Col lg={8}>
                            <Form.Item label="Actividad a desarrollar 3">{
                                getFieldDecorator('actividad_3',{
                                initialValue: this.state.user.actividad_3
                            })(
                                <Input
                                    disabled={true}
                                    onChange={(e) => this.updateData("actividad_3", e.target.value ? e.target.value : null)}
                                />
                            )}
                            </Form.Item>
                            </Col>

                            </Row>

                        </Card>

                        <Card   style={{ marginBottom: "10px" }}
                                title={"Datos Liqui"}>

                        <Row gutter={[8,8]}>
                        <Col lg={8}>
                            <Form.Item label="Tu plan">{
                                getFieldDecorator('plan',{
                                initialValue: this.state.user.plan
                            })(
                                <Input
                                    disabled={true}
                                    onChange={(e) => this.updateData("plan", e.target.value ? e.target.value : null)}
                                />
                            )}
                            </Form.Item>
                            </Col>

                            <Col lg={8}>
                            <Form.Item label="Fecha de inicio de plan">{
                                getFieldDecorator('fecha_inicio',{
                                initialValue: this.state.user.fecha_inicio
                            })(
                                <Input
                                    disabled={true}
                                    onChange={(e) => this.updateData("fecha_inicio", e.target.value ? e.target.value : null)}
                                />
                            )}
                            </Form.Item>
                            </Col>
                            <Col lg={8}>
                            <Form.Item label="Fecha de fin">{
                                getFieldDecorator('fecha_fin',{
                                initialValue: this.state.user.fecha_fin
                            })(
                                <Input
                                    disabled={true}
                                    onChange={(e) => this.updateData("fecha_fin", e.target.value ? e.target.value : null)}
                                />
                            )}
                            </Form.Item>
                            </Col>
                        </Row>

                        </Card>
                        <>
                            {this.state.user.tipo_usuario !== 'LITE' ? <Button
                                margin={"10px"}
                                onClick={this.showModal}
                                icon="deleteuser"
                            >Cancelar el Servicio
                            </Button> : null}
                        <Modal
                        title={"Solicitud de Baja"}
                        visible={this.state.visible}
                        onOk={this.handleOk}
                        onCancel={this.handleCancel}
                        footer={[
                            <Button key="back" onClick={this.handleCancel}>
                                Cancelar
                            </Button>,
                            <Button key="submit" type="primary" onClick={this.baja_liqui} hidden={this.isBajaOrInactivo()}>
                                Baja Liqui
                            </Button>,
                            <Button key="submit_all" type="primary" onClick={this.baja_todo} disabled={this.isBajaOrInactivo()}>
                                Baja monotributo y Liqui
                            </Button>
                        ]}
                        >
                        {bajaLabel}
                        </Modal>
                      </>
            </BaseComponent>
        )
    }}
}
const MyAccount = Form.create({ name: 'my-account' })(Micuenta);
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MyAccount));
